import React, { useState } from 'react';
import APopover from '../../../views/pages/manage/common/a-popover';
import AButton from '../../../views/pages/manage/common/form-fields-mui/AButton';
import { downloadTemplate } from './utils';
import { ReactComponent as DownloadIcon } from "assets/img/svg/fi_download.svg";
import { ReactComponent as ExcelIcon } from "assets/img/svg/excel.svg";
import ALoader from '../../../views/pages/manage/common/a-loader';
import { ReactComponent as DownloadIconBlack } from "assets/img/svg/downloadBlack.svg";


const Template = ({ type }) => {

    const [loading, setLoading] = useState(false);

    const downloadClickHandler = async () => {
        try {
            setLoading(true);
            await downloadTemplate(type.value);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);

        }
    }

    return (
        <>
            {loading && <ALoader position={"fixed"} />}
            <div className='d-flex justify-content-between align-items-center p-2' style={{ gap: '1rem' }}>
            <div className='d-flex justify-content-start align-items-center p-2' style={{ gap: '1rem' }}>
                <ExcelIcon />
                <b>{type.label}</b>
                </div>
                <DownloadIcon className='pointer' onClick={downloadClickHandler} />
            </div>
        </>
    )
}

const DownloadTemplate = ({
    permittedBulkTransferTypes
}) => {
    return (
        <APopover
            buttonComponent={openPopup =>
                <AButton
                    variant='outline'
                    size='xs'
                    onClick={openPopup}
                    outlineVariantColor={"#bfbfbf"}
                    textColor={"#000"}
                >
                    <DownloadIconBlack className='mr-2' />
                    Download Template
                </AButton>
            }

            menuComponent={closePopup =>
                <div>
                    {permittedBulkTransferTypes?.map(type => <Template key={type.value} type={type} />)}
                </div>
            }
        />
    );
}

export default DownloadTemplate;